"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgBold(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M13.066 0C16.444 0 19 2.604 19 6c0 2.054-.96 3.822-2.471 4.897C18.666 12.069 20 14.329 20 17c0 3.87-2.723 6.873-6.68 6.996l-.254.004H5c-.079 0-.156-.01-.23-.026l-.107-.032a.995.995 0 01-.507-.406l-.054-.096A.996.996 0 014 23V1a1 1 0 011-1h8.066zm-.278 12.001L6 12v10h7.066C16.023 22 18 19.878 18 17c0-2.847-2.016-4.969-4.969-4.969-.084 0-.165-.01-.243-.03zM13.066 2H6v8h7c2.283 0 4-1.717 4-4 0-2.23-1.569-3.896-3.73-3.995L13.066 2z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgBold;
exports.default = _default;